// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGCollapse = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 12",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#collapse__clip0_5218_10958)",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M3.442 4.613L.259 1.431C.1 1.283 0 1.07 0 .837 0 .39.363.027.81.027c.234 0 .446.1.594.26l3.149 3.148v-2.37c0-.469.38-.85.849-.85.237 0 .452.098.606.256.153.15.248.359.248.59v4.406c0 .467-.378.844-.844.844H1.016c-.468 0-.849-.38-.849-.849 0-.468.38-.849.85-.849h2.425z"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.604 7.48l3.182 3.183h.02c.12.142.194.325.194.527 0 .447-.363.81-.81.81-.203 0-.388-.075-.53-.197L7.508 8.63v2.368c0 .468-.38.849-.849.849-.468 0-.849-.38-.849-.85v-4.37c0-.234.097-.445.253-.597.153-.154.366-.25.601-.252h4.363c.023-.002.045-.003.068-.003.471 0 .854.383.854.854 0 .472-.383.854-.854.854-.023 0-.045 0-.065-.002H8.604zm3.201 3.183v-.001.001z"
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "collapse__clip0_5218_10958",
      children: /*#__PURE__*/_jsx("path", {
        transform: "rotate(-90 6 6)",
        d: "M0 0h12v12H0z"
      })
    })
  })]
}));
SVGCollapse.displayName = 'SVGCollapse';
export default SVGCollapse;